import { courseConstants } from './constants';
import { attendanceConstants } from './constants/attendanceConstants';


const INITIAL_STATE = { 
    course: {},
    qualificationsGrid: {},
    courseTeachers: [],
    subject: {},

    courseEvaluations:[],
    courseAttendance: [],
    courseAttendanceStatus: [],
    attendanceTypes: [],
    holidays: []
 };



export function courses(state = INITIAL_STATE, action) {

   switch (action.type) {

    // 
    case attendanceConstants.ADD_ATTENDANCE: 
    let attendanceCopy = [...state.courseAttendance] ;
    attendanceCopy.push(action.added) ;
    return {
        ...state,
        courseAttendance: attendanceCopy
        };  

    case attendanceConstants.REMOVE_ATTENDANCE: 
        return {
            ...state,
            courseAttendance: [...state.courseAttendance.filter(
                                            (att) => ! ( att.persona_id === action.deleted.student_id &&
                                                       att.attendance_id ===  action.deleted.attendance_id )
                                )]
            };  

            
    case attendanceConstants.ADD_ATTENDANCE_STATUS: 
        // remove if exists
        let courseAttendanceStatusCopy = state.courseAttendanceStatus.filter(f => f.status_date !== action.added.status_date);
        courseAttendanceStatusCopy.push(action.added) ;

        return {
            ...state,
            courseAttendanceStatus: courseAttendanceStatusCopy
            };  

    case attendanceConstants.LOAD_ATTENDANCE_STATUS:

        return {
            ...state,
            courseAttendanceStatus: action.courseAttendanceStatus
            };  

    case attendanceConstants.LOAD_HOLIDAYS:

        return {
            ...state,
            holidays: action.holidays
            };           

    case attendanceConstants.SHOW_COURSE_ATTENDANCE:

        return {
            ...state,
            courseAttendance: action.courseAttendance
            };  

            
    case attendanceConstants.LOAD_ATTENDANCE_TYPES:
        return {
            ...state,
            attendanceTypes: action.attendanceTypes.map( ( e ) => { e.value = e.type_id; e.label = e.description; return e } )
            };         
            
    case courseConstants.SHOW_COURSE_SUBJECTS:
        return {
            ...state,
            courseSubjects: action.courseSubjects
            };  
       
    case courseConstants.SHOW_COURSE_TEACHERS:
        return {
            ...state,
            courseTeachers: action.courseTeachers
           };   
    
    case courseConstants.SHOW_COURSE_EVALUATIONS:
        return {
            ...state,
            courseEvaluations: action.courseEvaluations
            };             

    case courseConstants.SHOW_QUALIFICATIONS:
        return {
            ...state,
            qualificationsGrid: action.qualificationsGrid
           };  

    case courseConstants.SHOW_SUBJECT:
    return {
        ...state,
        subject: action.subject
        };  

        
        // type: courseConstants.UNSCHEDULE_CLASS,
        //         unScheduledClass: json

    case courseConstants.UNSCHEDULE_CLASS:
 
        return {
            ...state,
            // courseSubjects: {...state.courseSubjects, 
            //                 schedule: { ...state.courseSubjects.schedule.filter(
            //                             (sch) => sch.course_subject_schedule_id != action.unScheduledClass.course_subject_schedule_id ) }
            //                 }
        };  
             
        
    case courseConstants.TUTOR_UNENROLED:

        return {
            ...state,
            course: {...state.course, 
                        tutors: state.course.tutors.filter((tutor) => tutor.persona_id !== action.unEnroledTutor.persona_id )}
        };  
          
        
    case courseConstants.TUTOR_ENROLED:
        let tutorsCopy = [...state.course.tutors] ;
        tutorsCopy.push(action.newTutor) ;

        return {
            ...state,
            course: {...state.course, tutors: tutorsCopy}
        };  
        

    case courseConstants.STUDENT_UNENROLED:
    
        return {
            ...state,
            course: {...state.course, 
                        students: state.course.students.filter((student) => student.persona_id !== action.unEnroledStudent.persona_id )}
        };  
         
    case courseConstants.STUDENT_ENROLED:
        let studentsCopy = [...state.course.students] ;
        studentsCopy.push(action.newStudent.persona) ;

        return {
            ...state,
            course: {...state.course, students: studentsCopy}
        };  
        
        


    case courseConstants.SHOW_COURSES:
        return {
            ...state,
            course: action.course
           };  
    case courseConstants.TOGGLE_STUDENT_MULTIPLE_ACTION_LIST:
        var courseCopy = state.course ;
        var absenceRankCopy = [...state.course.absenceRank] ;
        var studentCopy = action.student ;

        if (action.student.selected && action.student.selected === 1 ) studentCopy.selected = 0 ;
        else { studentCopy.selected = 1 } ;
        absenceRankCopy[action.index] = studentCopy;
        courseCopy.absenceRank = absenceRankCopy ;
       
        return {
            ...state,
            course: courseCopy
            };  
 
    default:
        return state
  }
} 